import { put, takeLatest } from "redux-saga/effects";
import { actions, initialState } from "./slice";
import { HomeState } from "../types";

function* getHomeDataSaga() {
  try {
    const data: HomeState = {
      ...initialState,
      loading: false,

      statusItems: [
        {
          labelKey: "HOME.STATUS.LEAD_QUOTE",
          value: 2,
          color: "#3498DB",
        },
        {
          labelKey: "HOME.STATUS.WAITING_ENGINEERING",
          value: 8,
          color: "#9B59B6",
        },
        {
          labelKey: "HOME.STATUS.READY_PRODUCTION",
          value: 3,
          color: "#F39C12",
        },
        {
          labelKey: "HOME.STATUS.IN_PRODUCTION",
          value: 22,
          color: "#95A5A6",
        },
        {
          labelKey: "HOME.STATUS.QUALITY_CONTROL",
          value: 4,
          color: "#2ECC71",
        },
      ],

      summaryCards: [
        {
          id: 1,
          value: 4,
          labelKey: "HOME.SUMMARY.DELIVERIES_TODAY",
          iconType: "delivery",
        },
        {
          id: 2,
          value: 12,
          labelKey: "HOME.SUMMARY.NEW_LEADS_THIS_WEEK",
          iconType: "leads",
        },
        {
          id: 3,
          value: 18,
          labelKey: "HOME.SUMMARY.ACTIVE_PRODUCTION_VEHICLES",
          iconType: "vehicles",
        },
        {
          id: 4,
          value: 7,
          labelKey: "HOME.SUMMARY.OPEN_ENGINEERING_TASKS",
          iconType: "engineering",
        },
      ],

      vehicles: Array.from({ length: 5 }).map((_, index) => ({
        id: index + 1,
        name: "Volvo FH 16",
        chassisNumber: "VLV-99283-X",
        arrivalDate: "01/04/2026",
        workOrder: "WO-8901",
      })),

      scheduleExceptions: [
        {
          id: 1,
          source: "WO-5501",
          statusKey: "HOME.STATUS.ENGINEERING",
          statusColor: "#9B59B6",
          statusTime: "5",
          exception: "3",
        },
        {
          id: 2,
          source: "WO-5502",
          statusKey: "HOME.STATUS.PRODUCTION",
          statusColor: "#F39C12",
          statusTime: "5",
          exception: "8",
        },
        {
          id: 3,
          source: "WO-5503",
          statusKey: "HOME.STATUS.IN_PRODUCTION",
          statusColor: "#95A5A6",
          statusTime: "3",
          exception: "5",
        },
      ],

      engineeringAlerts: [
        {
            id: 1,
            source: "WO-5501",
            value: "HOME.ENGINEERING_ALERT_VALUES.SCANIA_R500",
        },
        {
            id: 2,
            source: "WO-5502",
            value: "HOME.ENGINEERING_ALERT_VALUES.ISUZU_FSR",
        },
        {
            id: 3,
            source: "WO-5503",
            value: "HOME.ENGINEERING_ALERT_VALUES.CENTER_OF_GRAVITY_ERROR",
        },
        {
            id: 4,
            source: "WO-5501",
            value: "HOME.ENGINEERING_ALERT_VALUES.SCANIA_R500",
        },
        {
            id: 5,
            source: "WO-5502",
            value: "HOME.ENGINEERING_ALERT_VALUES.ISUZU_FSR",
        },
        {
            id: 6,
            source: "WO-5503",
            value: "HOME.ENGINEERING_ALERT_VALUES.CENTER_OF_GRAVITY_ERROR",
        },
    ],
    };

    yield put(actions.getHomeDataSuccess(data));
  } catch (error) {
    yield put(actions.getHomeDataFailed());
  }
}

export function* homeSaga() {
  yield takeLatest(actions.getHomeData.type, getHomeDataSaga);
}